import React from 'react';
import { type AlertProps } from 'antd';
import CommonAlert, { type Env0AlertProps } from 'components/common/feedback/alert';

// The seam between antd's prop surface and the wrapper's — the one call site to adapt if they diverge.
// Only an incompatible divergence errors here; a prop dropped from the Pick still flows at runtime.
export const toCommonProps = (props: AlertProps): Env0AlertProps => props;

/**
 * Takes antd's Alert props for the call sites written against antd, and renders the common wrapper.
 * Moving those sites onto the wrapper's own props removes this adapter.
 *
 * No `Object.assign` static, unlike BridgedButton's `__ANT_BUTTON`: Alert has no compat flag read off
 * the child's type, and nothing uses `Alert.ErrorBoundary`.
 */
export const BridgedAlert: React.FC<AlertProps> = props => {
  return <CommonAlert {...toCommonProps(props)} />;
};

export default BridgedAlert;
